import { ca } from '@cian/analytics';

import { useCallback } from 'react';

import { useGetCianAnalyticsPageViewObject } from '@/app/shared/hooks/useGetCianAnalyticsPageViewObject';

type TrackNewPage = VoidFunction;

export function useNewpageTracking(): TrackNewPage {
  const getCianAnalyticsPageViewObject = useGetCianAnalyticsPageViewObject();

  return useCallback<TrackNewPage>(
    () => ca('pageviewSite', getCianAnalyticsPageViewObject()),
    [getCianAnalyticsPageViewObject],
  );
}
